import api from "./api.js";
import agreementService from "./agreementService.js";
import appState from "./app-state.js";
import auth from "./auth.js";
import campaignService from "./campaignService.js";
import dataloader from "./dataloader.js";
import dynamicComponent from "./dynamic-component.js";
import eventBus from "./event-bus.js";
import featureCallbacks from "./feature-callbacks.js";
import featureHelper from "./feature-helper.js";
import fieldValueHelper from "./field-value-helper.js";
import intervalService from "./interval-service.js";
import loadingService from "./loading-service.js";
import logger from "./logging.js";
import mapHelpers from "./map-helpers.js";
import reportHelper from "./report-helper";
import detailHelper from "./detail-helper";
import tableHelper from "./table-helper";
import uiHelpers from "./ui-helpers";
import timezone from "./timezone-service";
import validationService from "./validation-service.js";
import cardSwipeService from "./card-swipe-service.js";
import entityBusinessService from "./entity-business-service.js";
import entityManager from "./entity-manager";
import ruleService from "./rule-service";
import ruleConfigService from "./rule-config-service.js";
import filterService from "./filter-service";
import formService from "./formService/formService.js";
import formsService from "./formService/formsService.js";
import userProfileSvc from "./user-profile";
import openIdService from "./oidcService";
import ruleValidator from "./rule-validator";
import noticeService from "./noticeService.js";
import noticeAdminService from "./noticeAdminService.js";
import securityService from "./security/index.ts";
import proxyService from "./proxyService.js";
import fileHandleStore from "./file-handle-store.js";
import fileUploadService from "./file-upload-service.js";
import gpsService from "./gpsService.ts";
import navigationService from "./navigationService";

const deps = [
	api,
	appState,
	auth,
	cardSwipeService,
	dataloader,
	detailHelper,
	dynamicComponent,
	entityBusinessService,
	entityManager,
	eventBus,
	featureCallbacks,
	featureHelper,
	fieldValueHelper,
	intervalService,
	loadingService,
	logger,
	mapHelpers,
	openIdService,
	reportHelper,
	ruleService,
	ruleConfigService,
	filterService,
	tableHelper,
	timezone,
	uiHelpers,
	validationService,
	userProfileSvc, 
	ruleValidator,
	formService,
	formsService,
	noticeService, 
	noticeAdminService,
	securityService,
	proxyService,
	fileHandleStore,
	fileUploadService,
	gpsService,
	navigationService,
	campaignService,
	agreementService
];

export default angular.module("vesl.services", deps).name;
